(function () {
  function initFadeUp() {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add('in');
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.fade-up').forEach((el) => obs.observe(el));
  }

  if (document.readyState === 'complete') {
    initFadeUp();
  } else {
    window.addEventListener('load', initFadeUp);
  }
})();